"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _components = _interopRequireDefault(require("../../styles/components"));

var _PanelContext = _interopRequireDefault(require("./PanelContext"));

var _Panel = _interopRequireDefault(require("./Panel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PanelStack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PanelStack, _React$Component);

  function PanelStack() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      index: 0
    });

    _defineProperty(_assertThisInitialized(_this), "getMemoizedContext", (0, _memoizeOne["default"])(function (count) {
      if (count === void 0) {
        count = 0;
      }

      return {
        stackSize: count,
        nextPanel: _this.nextPanel
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.setState({
        index: Number(event.target.value)
      });
    });

    return _this;
  }

  var _proto = PanelStack.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        isHostedApp = _this$props.isHostedApp;
    var index = this.state.index; // Removes null children to correct indexing when mapping through children

    var filteredChildren = children === null || children === void 0 ? void 0 : children.filter(function (child) {
      return child;
    });

    var titles = _react["default"].Children.toArray(filteredChildren).filter(function (child) {
      return child && child.props;
    }).map(function (child) {
      return child.props.title;
    });

    var contextProps = this.getMemoizedContext(_react["default"].Children.count(titles));
    return /*#__PURE__*/_react["default"].createElement(_PanelContext["default"].Provider, {
      value: contextProps
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].PanelStack, null, /*#__PURE__*/_react["default"].createElement(_components["default"].PanelStackHeader, {
      className: isHostedApp ? "panel-stack-media-tabs" : ""
    }, titles.length > 1 && titles.map(function (title, i) {
      return /*#__PURE__*/_react["default"].createElement(_components["default"].PanelStackButton, {
        key: title + "_" + i,
        value: i,
        onClick: _this2.handleClick,
        active: i === index
      }, title);
    })), _react["default"].Children.map(filteredChildren, function (child, i) {
      var _child$props, _child$props3;

      // If child is a player (only in HostedApp), display as usual.
      // This applies when having multiple mediaId tabs
      if (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.isPlayer) {
        var _child$props2;

        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: "" + (child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.title)
        }, child && i === index ? child : undefined);
      } // Else, force the panelstack child to render but not display
      // Needed to grab the transcript from the DOM for export
      // This applies for panel children (ie. Transcript or Media tabs)


      return /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        key: "" + (child === null || child === void 0 ? void 0 : (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.title),
        style: {
          display: "" + (child && i === index ? "flex" : "none")
        }
      }, child);
    })));
  };

  return PanelStack;
}(_react["default"].Component);

var _default = PanelStack;
exports["default"] = _default;